import { render, staticRenderFns } from "./GutenbergLibraryWidget.vue?vue&type=template&id=2c1017e7&scoped=true"
import script from "./GutenbergLibraryWidget.vue?vue&type=script&lang=js"
export * from "./GutenbergLibraryWidget.vue?vue&type=script&lang=js"
import style0 from "./GutenbergLibraryWidget.vue?vue&type=style&index=0&id=2c1017e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1017e7",
  null
  
)

export default component.exports